<template>
  <div class="sso-setup">
    <SsoViewSwitcher v-if="isOauthAdmin">
      <template #saml>
        <DpplAutoSizedButton
          v-if="!isActive && !pageLoading"
          class="mt-6 mb-6 ml-4"
          color="primary"
          @click="update({ isActive: true })"
        >
          Start SSO setup
        </DpplAutoSizedButton>
        <div
          v-else
          class="px-4 pb-4"
        >
          <SetupStep1 />
          <SetupStep2 class="mt-8" />
          <SetupStep3
            v-if="setupIsReady"
            class="mt-8"
          />
        </div>
      </template>
      <template #sso>
        <SetupOauth class="ml-4" />
      </template>
    </SsoViewSwitcher>

    <template v-else>
      <div v-if="oauthSetup">
        <SetupOauth class="mt-4" />
      </div>

      <DpplAutoSizedButton
        v-else-if="!isActive && !pageLoading"
        class="mt-6 mb-6 ml-4"
        color="primary"
        @click="update({ isActive: true })"
      >
        Start SSO setup
      </DpplAutoSizedButton>

      <div v-else class="px-4 pb-4">
        <SetupStep1 />
        <SetupStep2 class="mt-8" />
        <SetupStep3
          v-if="setupIsReady"
          class="mt-8"
        />
      </div>
    </template>
  </div>
</template>

<script>
import { mapState, mapActions } from 'pinia';
import { useAppAuthData } from '@/stores/app/authData';
import { useAppLoading } from '@/stores/app/loading';
import { useSettingsConfig } from '@/stores/settings/config';
import { useSettingsSsoSetup } from '@/stores/settings/ssoSetup';
import DpplAutoSizedButton from '@/components/datapeople/DpplAutoSizedButton.vue';
import SetupOauth from './SetupOauth.vue';
import SetupStep1 from './SetupStep1.vue';
import SetupStep2 from './SetupStep2.vue';
import SetupStep3 from './SetupStep3.vue';
import SsoViewSwitcher from './SsoViewSwitcher.vue';

export default {
  name: 'SsoSetup',

  components: {
    DpplAutoSizedButton, SetupOauth, SetupStep1, SetupStep2, SetupStep3, SsoViewSwitcher,
  },

  computed: {
    ...mapState(useAppLoading, ['pageLoading']),
    ...mapState(useSettingsConfig, ['config']),
    ...mapState(useSettingsSsoSetup, ['isActive', 'setupIsReady', 'isGoogle', 'isMicrosoft']),

    isOauthAdmin() {
      return useAppAuthData().authData.loginMethod === 'oauth';
    },

    oauthSetup() {
      return useAppAuthData().authData.oauthClient || this.isGoogle || this.isMicrosoft;
    },
  },

  async mounted() {
    await this.load();
  },

  methods: {
    ...mapActions(useSettingsSsoSetup, ['update', 'load']),
  },
};
</script>

<style lang="less" scoped>
.v-card-header {
  background-color: transparent !important;
  box-shadow: none !important;
}
.success-tooltip {
  background-color: @white;
  color: @text-darkest;
}
</style>
